import { render, staticRenderFns } from "./Piece.vue?vue&type=template&id=60a827d1&"
import script from "./Piece.vue?vue&type=script&lang=ts&"
export * from "./Piece.vue?vue&type=script&lang=ts&"
import style0 from "./Piece.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports